if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    },
  );
}

document.addEventListener('DOMContentLoaded', function () {

  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) return;

  const galleryId = mediaGallery.id.split('-').pop();
  const sliderComponent = document.getElementById(`GalleryViewer-template--${galleryId}`);
  if (!sliderComponent) return;

  const navigateSlider = (direction) => {

    const activeSlide = sliderComponent.querySelector('.slider__slide.is-active');

    const allSlides = Array.from(sliderComponent.querySelectorAll('.slider__slide'));

    const currentIndex = allSlides.findIndex((slide) => slide === activeSlide);

    let newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

    // Ajuste de índice
    newIndex = newIndex >= allSlides.length ? 0 : newIndex;
    newIndex = newIndex < 0 ? allSlides.length - 1 : newIndex;

    const targetSlide = allSlides[newIndex];
    const targetMediaId = targetSlide?.dataset?.mediaId;

    if (targetMediaId) {
      allSlides.forEach((slide) => slide.classList.remove('is-active'));
      targetSlide.classList.add('is-active');

      mediaGallery.setActiveMedia(targetMediaId);

      const counterCurrent = sliderComponent.querySelector('.slider-counter--current');
      if (counterCurrent) {
        counterCurrent.textContent = newIndex + 1;
      }
    }
  };

  const prevButton = sliderComponent.querySelector('.slider-button--prev');
  const nextButton = sliderComponent.querySelector('.slider-button--next');

  [prevButton, nextButton].forEach((button) => {
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        navigateSlider(button.classList.contains('slider-button--prev') ? 'prev' : 'next');
      });
    }
  });

  let touchStartX = 0;
  sliderComponent.addEventListener(
    'touchstart',
    (e) => {
      touchStartX = e.touches[0].clientX;
    },
    { passive: true },
  );

  sliderComponent.addEventListener(
    'touchend',
    (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > 50) {
        navigateSlider(diff > 0 ? 'next' : 'prev');
      }
    },
    { passive: true },
  );
});
